<template>
<div>

<div    @click="select($event, data)"   v-bind ='[{id:data.id}]' :class="{'page_list_row-selected': data.add_info.selected}"  class="page_list_row clearfloat selectable"    >

  <div class="gpage_photo"><img     v-bind ='{src:data.photo_100}'    />   </div>
  <div style="width:300px;" class="gpage_info selectable">
  <div class="glabeled_name selectable"  > <a v-bind ='{href:data.url}' target="_blank"  style="text-decoration:none; color:#42648b;">  <span >{{data.name.substring( 28,-1).toLowerCase()}}</span> <v-tooltip close-delay="1" bottom  v-if="data.name.length >28"  max-width="320">
    <span slot="activator">...</span><span>{{data.name}}</span> </v-tooltip> </a>  </div>
  <div  style="margin-top:-7px" class="glabeled selectable" >
    <v-tooltip v-if="data.can_see_members == '0'"   top   open-delay="300" close-delay="1" max-width="200"   >
      <span slot="activator" class="glabeled selectable"  style="color:#FF8F18"> Скрыто: {{data.members_count}} </span>
      <span>Сообщество скрыло подписчиков</span>
    </v-tooltip>
    <span class="glabeled selectable" v-else>
      <v-icon small>mdi-account-multiple</v-icon> {{data.members_count}}
      <v-icon small>mdi-account-multiple-plus</v-icon> {{data.new_count}}
      <v-icon small>mdi-account-multiple-minus</v-icon> {{data.new_out_count}}
    </span>

    <span v-if="data.activiti < 0 " style="color:red ; font-size:1.2em" > {{data.activiti}} </span>
    <span v-else-if="data.activiti > 0 " style="color:green ; font-size:1.2em" > +{{data.activiti}} </span>
  </div>
  <div  style="margin-top:-3px"  class="glabeled selectable" >
  <span v-if="data.cat_name != 'Общий список' && data.cat_name.length " class="glabeled selectable">  # {{data.cat_name}}  </span>
  <span v-if="data.cat_name != 'Общий список' && data.cat_name.length && data.bot_count"  style="font-weight:bold; color:#273C51"> | </span>
  <v-tooltip v-if="data.bot_count"  top   open-delay="300" close-delay="1" max-width="200">
  <span slot="activator" class="selectable"> <v-icon small>mdi-robot</v-icon> {{data.bot_count}} <span v-if="data.bot_percent">|</span> {{data.bot_percent}}<span v-if="data.bot_percent">%</span></span>
  <span>Количество зафиксированных ботов, процентное соотношение к колличеству новых подписок</span>
  </v-tooltip>
  </div>

  </div>


<div style="width:100px;height:100px;float:right"  class="gfunctions selectable"  >
<div    style="float:right; ">


<v-tooltip top   open-delay="300" close-delay="1" max-width="200"   >
<v-btn style="margin:0px"  icon small slot="activator" @click="checker(data,index)"><v-icon>mdi-update</v-icon></v-btn>
<span>Получить список новых подписчиков</span>
</v-tooltip>

<v-tooltip top   open-delay="300" close-delay="1" max-width="200"   >
<v-btn style="margin:0px"   icon small slot="activator" @click="history(data,index)"><v-icon>mdi-database-search</v-icon></v-btn>
<span>Список новых подписчиков и отписавшихся за все обновления активности</span>
</v-tooltip>

<v-tooltip top   open-delay="300" close-delay="1" max-width="200"   >
<v-btn style="margin:0px"   icon small slot="activator" @click="openParams(data,index)"><v-icon  >mdi-tune</v-icon></v-btn>
<span>Задать уникальные настройки, для данного сообщества</span>
</v-tooltip>

<v-tooltip top   open-delay="300" close-delay="1" max-width="200"   >
<v-btn style="margin:0px"  icon small slot="activator" @click="msg(data)"><v-icon small color="green">mdi-message</v-icon></v-btn>
<span>Список сообщений от заданий</span>
</v-tooltip>

<v-tooltip v-if="data.is_mute" top   open-delay="300" close-delay="1" max-width="200"   >
<v-btn style="margin:0px"  icon small slot="activator" @click="setMute(data,0)"><v-icon small color="red">mdi-account-off</v-icon></v-btn>
<span><v-icon small color="yellow">mdi-alert</v-icon><span style="color:yellow;margin-left:3px">Автообновлению запрещено обновлять данное сообщество.</span> Кликните что бы разрешить</span>
</v-tooltip>

<v-tooltip v-else top   open-delay="300" close-delay="1" max-width="200"   >
<v-btn style="margin:0px"  icon small slot="activator" @click="setMute(data,1)"><v-icon small color="green">mdi-account-plus</v-icon></v-btn>
<span>Автообновление может обновлять данное сообщество, кликните если хотите запретить</span>
</v-tooltip>

<v-tooltip top   open-delay="300" close-delay="1" max-width="200"   >
<v-btn style="margin:0px"  icon small slot="activator" @click="remove(data,index)"><v-icon color="red">mdi-close</v-icon></v-btn>
<span>Удалить сообщество из списка активности</span>
</v-tooltip>


</div>
</div>

  </div>

</div>
</template>




<script>
import axios from 'axios'
export default {
props: ['data','index', 'groups', 'modals'],
 data: function(){
  return {
   ui:{
     options: false
   },
   isSelected: false
  }
},
methods: {

 checker: function (data,index){


   this.groups.checker.foundData.selector = false
   this.groups.checker.foundData.foundIds = []
   this.groups.checker.foundData.displayIds = []
   this.groups.checker.foundData.selectedIds = []
   this.groups.checker.foundData.offset = 0

   this.groups.checker.foundDataOut.selector = false
   this.groups.checker.foundDataOut.foundIds = []
   this.groups.checker.foundDataOut.displayIds = []
   this.groups.checker.foundDataOut.selectedIds = []
   this.groups.checker.foundDataOut.offset = 0








   this.groups.checkList = []
   this.groups.checkList.push(data.id)

   this.groups.modals.checkGroup = true
 },
  remove: function(data,index){
    this.groups.deleteId = data     //id_of_group
    this.groups.selected.push(data)
    this.modals.deleteGroup = true
 },

openParams(data,index){
  this.groups.paramsItem = data
  this.groups.modals.gr_params = true
},

 history: function(data,index){

   this.groups.history.historyId = data.id_of_group
   this.modals.history = true
   this.getHistoryList(data.id_of_group)

},
msg(data){
this.groups.msgItem = data
this.groups.modals.msg = true
},
setMute(data,mode){
axios('http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/activiti/groups/set_mute.php', {
method: 'POST',
data:{
grId: data.id_of_group,mode:mode
}
})
.then( response => {
if(response.data.rsp == 'ok'){data.is_mute = mode}
})
},
getHistoryList: function(grId){

  this.groups.history.foundData.foundIds = []
  this.groups.history.foundData.displayIds = []
  this.groups.history.foundData.selector = false
  this.groups.history.foundData.selectedIds = []
  this.groups.history.foundData.offset = []

  this.groups.history.foundDataOut.foundIds = []
  this.groups.history.foundDataOut.displayIds = []
  this.groups.history.foundDataOut.selector = false
  this.groups.history.foundDataOut.selectedIds = []
  this.groups.history.foundDataOut.offset = []


  axios('http://'+this.$store.state.localhost+'/'+this.$store.state.path+'/activiti/groups/groups_history.php', {

       method: 'POST',
       data: {
         grId: grId,

       }
     })
     .then( response => {
       this.groups.history.foundData.foundIds = response.data.in
       this.groups.history.foundDataOut.foundIds = response.data.out

     })
},

select: function(event,data){

  let classes = event.target.className.split(' ')
   if(classes.indexOf('selectable') !== -1){
     data.add_info.selected = !data.add_info.selected
      if(data.add_info.selected  ){

        this.groups.selected.push(data)



      } else   this.groups.selected.splice(this.groups.selected.indexOf(data),1)



 }


},


},
mounted(){
//this.groups.displayCount = 15
},
}
</script>

<style>
.clearfloat:after {
 content: "";
 display: table;
 clear: both;
}

.page_list_row_selected{
background-color : #EDF0F5;
border-radius : 7px
}



.page_list_row {

  margin: 15px;


  }

.page_list_row:hover {
  margin: 15px;
  border-radius:5px;
  cursor: pointer;
  }

.page_list_row .gpage_info  {

 padding-top: 10px;
 float: left;
   margin-bottom: 5px;
 margin-right: 25px;
   overflow: hidden;

   width: 250px;
 min-height: 80px;
}

.page_list_row .gpage_info .glabeled_name{


    margin-bottom: 5px;
  color: #42648b;
    font-weight: 700;
   -webkit-font-smoothing: antialiased;
   -moz-osx-font-smoothing: grayscale;

}
.page_list_row .gpage_info .glabeled_name:first-letter{
   text-transform: capitalize;
}




.page_list_row .glabeled {

   color: #656565;
}


.page_list_row .gfunctions {
   padding: 7px 0 0;
  position: relative;
   overflow: hidden;
   width: 150px;
   height: 80px;
 }




.page_list_row .gpage_photo {


   float: left;
   margin: 3px;
   margin-right: 9px;
   position: relative;
   width: 80px;
   height: 80px;
   overflow: hidden;
}

.page_list_row .gpage_photo img {


   width: 80px;
   height: 80px;
   border-radius: 50%;
   -moz-force-broken-image-icon: 0;
   background-color: #fafbfc;
}



</style>
